import { formatSnakeLabel } from "@/lib/labels";

export const buildRunSelectionSearchParams = (
  current: URLSearchParams,
  runId: string | null,
): URLSearchParams => {
  const next = new URLSearchParams(current);
  if (runId) {
    next.set("runId", runId);
  } else {
    next.delete("runId");
  }
  return next;
};

export const buildRunSearchParams = (current: URLSearchParams, search: string): URLSearchParams => {
  const next = new URLSearchParams(current);
  const trimmedSearch = search.trim();
  if (trimmedSearch) {
    next.set("search", trimmedSearch);
  } else {
    next.delete("search");
  }
  next.delete("runId");
  return next;
};

export const formatRunJobTypeLabel = (jobType: string): string => formatSnakeLabel(jobType);

export const formatRunEventTypeLabel = (eventType: string): string => formatSnakeLabel(eventType);

export const formatRunDuration = (durationMs: number | null): string => {
  if (durationMs === null) {
    return "—";
  }

  if (durationMs < 1000) {
    return `${durationMs}ms`;
  }

  if (durationMs < 60_000) {
    const seconds = durationMs / 1000;
    const formattedSeconds = seconds.toFixed(seconds >= 10 ? 0 : 1).replace(/\.0$/, "");
    return `${formattedSeconds}s`;
  }

  const totalSeconds = Math.round(durationMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
};

const IMAGE_REGENERATION_JOB_TYPE = "social_post_image_regeneration";

export const buildRunImageRegenerationInspectorPath = (run: {
  jobType: string;
  workerJobIdempotencyKey: string;
}): string | null => {
  const generationTaskId = run.workerJobIdempotencyKey.trim();
  if (run.jobType !== IMAGE_REGENERATION_JOB_TYPE || !generationTaskId) {
    return null;
  }

  const params = new URLSearchParams({ generationTaskId });
  return `/image-regenerations?${params.toString()}`;
};
